








import { defineComponent } from '@vue/composition-api'
import { CartUtils } from '@/mixins/cart-utils'
import CartIconSvg from './CartIconSvg.vue'

export default defineComponent({
  name: 'CartIcon',
  components: { CartIconSvg },
  mixins: [CartUtils],
  created() {
    ;(this.getCartData as typeof CartUtils.methods.getCartData)(null, null, null, false)
  },
  computed: {
    cartItemCount() {
      // Need to return 0 as a string due to vuetify 2 bug interpreting number 0 as 'false'
      return (this.$store.getters['cart/cartItemCount'] || 0).toString()
    },
  },
})
